module.exports = __webpack_public_path__ + "media/images/shopping/complete/eyecatch-staff-02-f04295b671ec4bb294234f90974bc48f.svg";